import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

interface NotificationState {
    unreadCount: number;
}

const initialState: NotificationState = {
    unreadCount: 0
};

export const fetchUnreadCount = createAsyncThunk(
    "Notifications/update",
    async () => {
        const res = await axios.get("/NotificationUserApi/GetUserUnreadCount");
        return res.data.UpdatedItem;
    }
);

const notificationsSlise = createSlice({
    name: "Notifications",
    initialState,
    reducers: {
        setUnreadCount: (state, action: PayloadAction<number>) => {
            state.unreadCount = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchUnreadCount.fulfilled, (state, action) => {
            state.unreadCount = action.payload;
        });
    }
});

export const { setUnreadCount, update } = notificationsSlise.actions;
export default notificationsSlise.reducer;